var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M1 1L7 7L13 1","stroke":"#333333","stroke-width":_vm.strokeWidth}})])}
var staticRenderFns = []

export { render, staticRenderFns }